import React, { FC, HTMLAttributes } from 'react';

const Spacer: FC<HTMLAttributes<HTMLDivElement>> = (props) => {
  return <div {...props} style={{ flexGrow: 1, ...props.style }} />;
};

export default Spacer;
